module.exports = __webpack_public_path__ + "img/worksbot_img19121104.0fefb871.jpg";